import { Map } from "../../Map";
import * as leaflet from "leaflet";

export const NAME = "leaflet-api";

export function test() {
    return true;                // FIXME?
}

export function mount(map) {
    if (map.node.nodeName !== "DIV") {
        system.error("leaflet will only mount on <div> elements");

        return undefined;
    }

    const leaflet_map = leaflet.map(map.node).setView([map.props.initial_center[1], map.props.initial_center[0]], map.props.initial_zoom);

    leaflet.tileLayer(
        map.props.tile_url_template,
        { attribution: map.props.attribution, }
    ).addTo(leaflet_map);

    const feature_layer = leaflet.geoJSON().addTo(leaflet_map);

    for (const feature of map.props.geojson_features) {
        const style = Map.featureToStyle(feature);

        if (style) {
            feature_layer.addData(feature).setStyle(style);
        } else {
            feature_layer.addData(feature);
        }
    }

    feature_layer.eachLayer(layer => {
        const content = Map.featureToPopup(layer.feature);

        if (content) {
            layer.bindPopup(content);
        }
    });

    return {
        map,
        // TODO: ...
    };
}
